import httpbaseURL from "../common/axios";
class Groupservices {
  GetEntityByModuleId(moduleid, OrganizationId) {
    return httpbaseURL.httpMSInventoryUrl.get(
      "/EntityMaster/GetEntityByModuleId?ModuleId=" +
        moduleid +
        "&OrganizationId=" +
        OrganizationId +
        ""
    );
  }
  GetRightsByRoleId(RoleId, ModuleId, OrganizationId) {
    return httpbaseURL.httpMSInventoryUrl.get(
      "/EntityOperationsDeptRoleMap/GetRightsByRoleIdModuleId?RoleId=" +
        RoleId +
        "&ModuleId=" +
        ModuleId +
        "&OrganizationId=" +
        OrganizationId +
        ""
    );
  }
}
export default new Groupservices();
